﻿import { Inject, Injectable } from '@angular/core'
import { Route, Router, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';
import { BuildingQuestionParam } from '../viewmodel';
import { AppConfig } from '../app.config';
import { Location } from '@angular/common';

@Injectable()
export class SharedService {

    public _customError: boolean = AppConfig.config.customError;
    public _customErrorMsg: string = AppConfig.config.customErrorMsg;

    selectedEntity: any;
    selectedBldg: any;
    currentRoute: any;
    lastRoute: any;

    public navigationRestrictedUrls: Array<string> = [];

    constructor(private router: Router, private location: Location) {
        this.navigationRestrictedUrls.push('/addbuilding');
        this.navigationRestrictedUrls.push('/createentity');
        this.navigationRestrictedUrls.push('/entity/addsiteentity');
    }

    setLocalStorage(key: string, data: any) {
        localStorage.setItem(key, JSON.stringify(data));
    }

    getLocalStorage(key: string) {
        return JSON.parse(localStorage.getItem(key));
    }

    removeLocalStorage(key: string) {
        localStorage.removeItem(key);

    }

    setData(key: string, data: any) {

        sessionStorage.setItem(key, data);
    }

    setJsonData(key: string, data: any) {
        sessionStorage.setItem(key, JSON.stringify(data));
    }

    getData(key: string) {
        return sessionStorage.getItem(key);

    }

    getJsonData(key: string) {
        return JSON.parse(sessionStorage.getItem(key));
    }

    removeData(key: string) {
        sessionStorage.removeItem(key);
    }

    manageSession(pageName: string) {

        if (pageName == 'home') {
            this.removeData('id');
            this.removeData('entityParam');
            this.removeData('SiteEntityParam');
            this.removeData('BuildingQuestionParam');

        }
        if (pageName == 'application') {
            this.removeData('entityParam');
            this.removeData('SiteEntityParam');
            this.removeData('BuildingQuestionParam');
        }

    }

    setBuildingQuestionParam(building, buildingAddress) {

        var BQP = new BuildingQuestionParam();
        BQP.devProjectBuildingId = building.DevProjectBuildingId;
        BQP.siteProjectBuildingId = building.SiteProjectBuildingId;
        BQP.bldgId = building.BuildingId;
        BQP.buildingAddress = buildingAddress;
        BQP.mood = 'A';
        this.setJsonData('BuildingQuestionParam', BQP);
    }


    navigateSummary() {
        let currentUrl = this.location.path();     
        if (this.navigationRestrictedUrls.indexOf(currentUrl) != -1) {
            this.router.navigate(["/entity/application"], { replaceUrl: true });
        }
        else {
            this.router.navigate(["/entity/application"]);
        }
    }

    navigateHome() {   
        let currentUrl = this.location.path();     
        if (this.navigationRestrictedUrls.indexOf(currentUrl) != -1) {
            this.router.navigate(["/home"], { replaceUrl: true });
        }
        else {
            this.router.navigate(["/home"]);
        }
    }

    navigateAccount() {
        let currentUrl = this.location.path();
        if (this.navigationRestrictedUrls.indexOf(currentUrl) != -1) {
            this.router.navigate(["/account"], { replaceUrl: true });
        }
        else {
            this.router.navigate(["/account"]);
        }
    }

    getCustomError(msg) {
        if (this._customError)
            return this._customErrorMsg;
        else
            return msg;
    }

    processError(msg) {
        window.scrollBy(0, -1);  //trigger sticky error message
        if (msg!=null && msg.indexOf('SessionNotExists') !== -1) {
            this.router.navigate(["/login?session=0"]);
        }
    }

    scroll() {
        window.scrollBy(0, -1);
    }


}